import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Customer/";

const customerAPIService = new APIService(baseUrl);

export async function GetCustomerList(args) {
  var url = "getallcustomers";
  return await customerAPIService.postData(url, args);
}

// Customer Detail API
export async function GetCustomerDetails(customerid) {
  var url = "getcustomerdetail?customerid=" + customerid;
  return await customerAPIService.fetchData(url);
}

export async function GetCustomerShortDetail(customerid) {
  var url = "getcustomershortdescbyid?customerid=" + customerid;
  return await customerAPIService.fetchData(url);
}

export async function AddCustomer(customer) {
  var url = "addcustomer";
  return await customerAPIService.putData(url, customer);
}

export async function UpdateCustomer(customer) {
  var url = "updatecustomer";
  return await customerAPIService.patchData(url, customer);
}

export async function DeleteCustomer(customerId) {
  var url = "deletecustomer?customerid=" + customerId;
  return await customerAPIService.deleteData(url);
}

export async function AddCustomerDoc(doc) {
  var url = "addcustomerdoc";
  return await customerAPIService.putData(url, doc);
}

export async function DeleteCustomerDoc(docId) {
  var url = "deletecustomerdoc?docid=" + docId;
  return await customerAPIService.deleteData(url);
}

export async function GetDocumentById(docid) {
  const customHeaders = {
    Mode: "view",
  };
  var url = "getcustomerdocbyid?docid=" + docid;
  return await customerAPIService.fetchData(url, customHeaders);
}

// Reference Documents API
export async function ReferenceDocumentsList(customerid) {
  var url = "getcustomerdocs?customerid=" + customerid;
  return customerAPIService.fetchData(url);
}

export async function SearchCustomerNames(name) {
  var url = "searchcustomer?searchText=" + name;
  return await customerAPIService.fetchData(url);
}

export async function GetCustomerBillingEntity(customerid) {
  var url = `getcustomerbillingentities?customerid=${customerid}`;
  return await customerAPIService.fetchData(url);
}

export async function ArchiveCustomers(customerIds, archived) {
  var url = `archivecustomers?customerIds=${customerIds}&archived=${archived}`;
  return await customerAPIService.fetchData(url);
}
